<template>
	<div v-show="displayValidationRunning">Running Validation Check...</div>
	<div v-show="!displayValidationRunning">
		<!-- Page Label -->
		<PageLabel :helpPageName="'Assessments' + props.tabName.replace(/\s+/g, '') + 'Result'">Results</PageLabel>

		<div v-show="!displayResult && displayWarning">
			<Card>
				<template #title>Warnings:</template>
				<template #content>
					<p v-for="(item, index) in warningMessage" :key="index" class="m-0" v-html="item"></p>
				</template>
			</Card>
		</div>

		<div class="flex flex-row gap-4 mb-4">
			<!-- Colonna sinistra: Tabs -->
			<div class="flex-1">
				<!-- Info saved result -->
				<div v-show="resultSaveButton" class="flex items-center justify-between w-full gap-2 mb-4">
					<div class="flex gap-2 items-center" @mouseenter="showOverlay($event, actualSavedResult)">
						<font-awesome-icon v-if="actualSavedResult.length > 0" :icon="['far', 'info-circle']" />{{ actualSavedResultText }}
					</div>
				</div>
				<!-- <div v-show="resultSaveButton" class="flex items-center justify-end w-full gap-2 mb-4" v-if="actualSavedResultText">
				{{ actualSavedResultText
				}}<span @mouseenter="showOverlay($event, actualSavedResult)"> <font-awesome-icon :icon="['far', 'triangle-exclamation']" /></span>
			</div> -->

				<!-- Tabs (only when displayResult is true and resultSaveButton is true) -->
				<div v-show="displayResult && resultSaveButton" class="i2Panel">
					<Tabs value="0">
						<TabList @click="changeTab">
							<Tab value="0">
								<FontAwesomeIcon :icon="['far', 'arrows-spin']" title="End of Life" />
								<span class="tabmenu ml-2">Results by Life Cycle Stage</span>
							</Tab>
							<Tab value="1"
								><FontAwesomeIcon :icon="['far', 'boxes-packing']" title="End of Life" /> <span class="tabmenu ml-2">Results by Step</span></Tab
							>
							<Tab value="2"
								><FontAwesomeIcon :icon="['far', 'flask-round-potion']" title="End of Life" />
								<span class="tabmenu ml-2">Results by Material Composition</span></Tab
							>
							<Tab value="3"
								><FontAwesomeIcon :icon="['far', 'trash-can-list']" title="End of Life" />
								<span class="tabmenu ml-2">Results by Process Waste</span></Tab
							>
						</TabList>
						<TabPanels>
							<TabPanel value="0"
								><resultStepBiologicsAG
									:ref="(el) => (resultStepBiologicsAGControl = el as any)"
									:assessmentId="assessmentId"
									:tabId="props.tabId"
									:tabName="props.tabName"
									:steps="props.steps"
									:activeEmissionFactors="activeEmissionFactors"
									:calculationOptions="calculationOptions"
									:selectedUnit="calculatedUnitObject"
									:selectedStep="calculatedStepObject"
									:outputQuantityDescription="outputQuantityDescription" /></TabPanel
							><TabPanel value="1"
								><resultByStepBiologicsAG
									:ref="(el) => (resultByStepBiologicsAGControl = el as any)"
									:assessmentId="assessmentId"
									:tabId="props.tabId"
									:tabName="props.tabName"
									:steps="props.steps"
									:activeEmissionFactors="activeEmissionFactors"
									:calculationOptions="calculationOptions"
									:selectedUnit="calculatedUnitObject"
									:selectedStep="calculatedStepObject"
									:outputQuantityDescription="outputQuantityDescription"
								></resultByStepBiologicsAG></TabPanel
							><TabPanel value="2"
								><resultByMaterialCompositionBiologicsAG
									:ref="(el) => (resultByMaterialCompositionBiologicsAGControl = el as any)"
									:assessmentId="assessmentId"
									:tabId="props.tabId"
									:tabName="props.tabName"
									:steps="props.steps"
									:activeEmissionFactors="activeEmissionFactors"
									:calculationOptions="calculationOptions"
									:selectedUnit="calculatedUnitObject"
									:selectedStep="calculatedStepObject"
									:outputQuantityDescription="outputQuantityDescription"
								></resultByMaterialCompositionBiologicsAG></TabPanel
							><TabPanel value="3"
								><resultByProcessWasteBiologicsAG
									:ref="(el) => (resultByProcessWasteBiologicsAGControl = el as any)"
									:assessmentId="assessmentId"
									:tabId="props.tabId"
									:tabName="props.tabName"
									:steps="props.steps"
									:activeEmissionFactors="activeEmissionFactors"
									:calculationOptions="calculationOptions"
									:selectedUnit="calculatedUnitObject"
									:selectedStep="calculatedStepObject"
									:outputQuantityDescription="outputQuantityDescription"
								></resultByProcessWasteBiologicsAG
							></TabPanel>
							<TabPanel value="4"
								><AssessmentDetailsAG
									ref="assessmentDetailsControl"
									:assessmentId="assessmentId"
									:tabId="props.tabId"
									:activeEmissionFactors="activeEmissionFactors"
									:isWeighted="isWeighted"
							/></TabPanel> </TabPanels
					></Tabs>
				</div>

				<!-- Loading message (when displayResult is true but resultSaveButton is false) -->
				<div v-show="displayResult && !resultSaveButton">Results are being calculated...</div>
			</div>

			<!-- Colonna destra: Buttons + SelectableList -->
			<div class="flex flex-col gap-2" style="min-width: 400px; max-width: 450px">
				<!-- Buttons -->
				<div class="flex flex-row items-center gap-2 justify-end flex-wrap">
					<Button class="btn p-button" v-if="!displayResult" @click="invokeResult">Calculate</Button>
					<Button class="btn p-button" v-if="displayResult" @click="invokeResult">Recalculate</Button>
					<template v-if="displayResult">
						<Button class="btn p-button" :disabled="!resultSaveButton" @click="exportCalculationLog()">Log</Button>
						<Button class="btn p-button" :disabled="!resultSaveButton" @click="exportToBody()">Export</Button>
						<Button class="btn p-button" :disabled="!resultSaveButton" @click="saveResult()" v-bind="lock.button.value" v-tooltip="lock.tooltip"
							>Save Result</Button
						>
					</template>
				</div>
				<!-- Output Quantity Section -->
				<div class="flex flex-col gap-2">
					<I2Label label="Output Quantity" helpElementName="OutputQuantity" />
					<div class="flex gap-2">
						<InputNumber v-model="outputQuantity" placeholder="Enter quantity" :min="0" :maxFractionDigits="4" class="flex-1" />
						<Dropdown
							v-model="selectedUnit"
							:options="weightUnits"
							optionLabel="unitName"
							optionValue="id"
							placeholder="Select Unit"
							:filter="weightUnits.length > 10"
							class="flex-1"
						/>
					</div>
				</div>

				<!-- Step Selection -->
				<div class="flex flex-col gap-2">
					<I2Label label="Step" helpElementName="StepSelection" />
					<Dropdown
						v-model="selectedStep"
						:options="stepsWithAllOption"
						:optionLabel="(step: Step) => (step.stepNumber === null ? step.stepName! : `${step.stepNumber} - ${step.stepName}`)"
						optionValue="id"
						placeholder="Select Step"
						:filter="stepsWithAllOption.length > 10"
						class="w-full"
					/>
				</div>
				<!-- Weighted Toggle -->
				<div v-if="weightedOptionEnabled" class="flex items-center gap-2">
					<ToggleSwitch v-model="isWeighted" inputId="weightedToggle" />
					<I2Label label="Weighted" helpElementName="WeightedToggle" />
				</div>

				<!-- SelectableList -->
				<SelectableList
					v-model="reportsStore.selectedEmissionFactorNames"
					:options="visibleEmissionFactors"
					option-label="emissionFactorName"
					option-value="emissionFactorName"
					placeholder="Select Emission Factors"
					:filter="true"
					:preserve-option-order="true"
				/>

				<!-- Step Flow Visualization -->
				<div v-if="availableSteps.length > 0" :style="{ height: Math.max(300, availableSteps.length * 70) + 'px' }">
					<VueFlowGraph id="biologics-step-graph" :key="stepGraphKey" :nodes="stepGraph.nodes" :edges="stepGraph.edges" disabled>
						<template #overlay>
							<svg
								v-if="highlightPath"
								style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; z-index: -1; overflow: visible"
							>
								<path
									:d="highlightPath"
									fill="var(--color-primary, #3b82f6)"
									fill-opacity="0.08"
									stroke="var(--color-primary, #3b82f6)"
									stroke-width="3"
									stroke-linejoin="round"
								/>
							</svg>
						</template>
					</VueFlowGraph>
				</div>
			</div>
		</div>
		<Dialog :visible="dialogSaveResult2" style="width: 50rem" modal :closable="false">
			<template #header>
				<div class="flex justify-between w-full">
					<h1>Save Result</h1>
				</div>
			</template>
			<I2FormRow>
				<I2FormField label="Result Name">
					<InputText
						v-model="resultName"
						placeholder="Please enter result name"
						:class="{ 'p-invalid': saveAttempted && !resultName, '': resultName !== undefined }"
					/>
				</I2FormField>
			</I2FormRow>
			<div class="mt-6 flex items-center gap-2">
				<ToggleSwitch v-model="showEmissionFactors" />
				<span class="text-gray-700">Show Emission Factors</span>
			</div>
			<div v-if="showEmissionFactors" class="mt-4">
				<div class="border border-gray-300 rounded-md">
					<!-- Header row -->
					<div class="flex justify-between items-center py-3 px-3 bg-gray-50 border-b border-gray-300 font-semibold text-gray-800">
						<span>Emission Factors</span>
						<span>Values</span>
					</div>
					<!-- Scrollable content - shows ALL emission factors -->
					<div class="max-h-60 overflow-y-auto">
						<div
							v-for="f in reportsStore.emissionFactors"
							:key="f.emissionFactorName"
							class="flex justify-between items-center py-2 px-3 border-b border-gray-200 last:border-b-0"
						>
							<span class="text-gray-700">{{ f.emissionFactorName }}</span>
							<span class="text-gray-900">{{
								(() => {
									const value = getEmissionFactorValue(f.emissionFactorName!)
									return valueToStringFormatter(value)
								})()
							}}</span>
						</div>
					</div>
				</div>
			</div>
			<I2FormRow class="mt-6">
				<I2FormField label="Result Description">
					<Textarea v-model="resultDescription" placeholder="Please enter result description" />
				</I2FormField>
			</I2FormRow>
			<template #footer>
				<div class="flex gap-2 align-right">
					<Button id="btnapply" type="button" @click="dialogSaveResult2 = false">Cancel</Button>
					<Button id="btnSaveProject" v-show="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Create)" @click="saveTheResult('save')">
						Save
					</Button>
				</div>
			</template>
		</Dialog>
		<Popover ref="op">
			<div @mouseleave="hideOverlay">
				<Tabs :value="0">
					<TabList>
						<Tab v-for="(singleSelectData, index) in selectedDataForOverlay" :value="index">
							<span class="ml-2">{{ singleSelectData.date }}</span>
						</Tab>
					</TabList>
					<TabPanels>
						<TabPanel v-for="(singleSelectData, index) in selectedDataForOverlay" :value="index">
							<ProductProcessTooltip :data="singleSelectData.data" /> </TabPanel
					></TabPanels>
				</Tabs>
			</div>
		</Popover>
	</div>
</template>
<script setup lang="ts">
import { ref, onMounted, onActivated, watch, computed } from "vue"
import Tabs from "primevue/tabs"
import TabList from "primevue/tablist"
import Tab from "primevue/tab"
import TabPanels from "primevue/tabpanels"
import TabPanel from "primevue/tabpanel"
import InputText from "primevue/inputtext"
import InputNumber from "primevue/inputnumber"
import Dropdown from "primevue/dropdown"
import Button from "primevue/button"
import ToggleSwitch from "primevue/toggleswitch"
import Dialog from "primevue/dialog"
import Popover from "primevue/popover"
import Card from "primevue/card"
import OverlayPanel from "primevue/overlaypanel"
import MultiSelect from "primevue/multiselect"
import { EmissionFactors } from "../../entities/NSwagGenerated"
import { useDateTimeHelper, formatExportTimestamp } from "@/composables/dateTimeHelper"
import {
	ApiClient,
	DataToSave,
	AllResultsOther,
	ExportRequestOther,
	ProductProcessProxy,
	LifeCycleResult,
	FeatureFlagClient,
	CalculationOptions,
	Unit,
	Step,
	UnitOfMeasureClient,
	IntermediateStep,
} from "../../entities/NSwagGenerated"
import { SessionInfo, PageAccess } from "../auth/personSessionData"
import { useToast } from "primevue/usetoast"
import { EventBus } from "@/eventBus"
import { library } from "@fortawesome/fontawesome-svg-core"
import {
	faInfoCircle,
	faTrash,
	faPen,
	faFloppyDisk,
	faXmarkLarge,
	faArrowsSpin,
	faBoxesPacking,
	faFlaskRoundPotion,
	faTrashCanList,
	faTriangleExclamation,
} from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
library.add(
	faTrash,
	faPen,
	faInfoCircle,
	faFloppyDisk,
	faXmarkLarge,
	faArrowsSpin,
	faBoxesPacking,
	faFlaskRoundPotion,
	faTrashCanList,
	faTriangleExclamation
)

import resultStepBiologicsAG from "./resultStepBiologicsAG.vue"
import resultByStepBiologicsAG from "./resultByStepBiologicsAG.vue"
import resultByMaterialCompositionBiologicsAG from "./resultByMaterialCompositionBiologicsAG.vue"
import resultByProcessWasteBiologicsAG from "./resultByProcessWasteBiologicsAG.vue"
import ProductProcessTooltip from "./ProductProcessTooltip.vue"
import PageLabel from "./pageLabel.vue"
import SelectableList from "./SelectableList.vue"
import VueFlowGraph from "./VueFlowGraph.vue"
import { Node, Edge } from "@vue-flow/core"
import { layout, computeHighlightPath } from "../composables/elkLayout"
import I2FormField from "@/crispify/crispy-components/I2FormField.vue"
import axios from "axios"
import { useConfirm } from "primevue/useconfirm"
import { useReportsStore } from "@/store/reportsStore"
import AssessmentDetailsAG from "./assessmentDetailsAG.vue"
import { useAssessmentStore } from "@/store/assessmentStore"
import { useAssessmentLock } from "@/composables/assessmentLock"
import { buildAssessmentResultName, parseDuplicateResultResponse } from "@/composables/resultSaveNaming"
import { valueToStringFormatter } from "@/composables/resultGridHelper"

const confirm = useConfirm()
const assessmentStore = useAssessmentStore()
const lock = useAssessmentLock(assessmentStore)
const toast = useToast()
const apiClient = new ApiClient(import.meta.env.VITE_API_URL?.toString())
const featureFlagClient = new FeatureFlagClient(import.meta.env.VITE_API_URL?.toString())
const unitOfMeasureClient = new UnitOfMeasureClient(import.meta.env.VITE_API_URL?.toString())
const reportsStore = useReportsStore()

async function refreshEmissionFactorOptions() {
	await reportsStore.loadEmissionFactors()
	reportsStore.syncSelectionsWithAvailableEmissionFactors()
}

// Load weight-based units from the API
async function loadWeightUnits() {
	try {
		const units = await unitOfMeasureClient.getUnitsByTypeName("Weight")
		weightUnits.value = units || []
		// Sort alphabetically by unit name
		weightUnits.value.sort((a, b) => (a.unitName || "").localeCompare(b.unitName || ""))

		// Set default to kg
		const kgUnit = weightUnits.value.find((u) => u.unitName?.toLowerCase() === "kg")
		if (kgUnit && !selectedUnit.value) {
			selectedUnit.value = kgUnit.id
		}
	} catch (error) {
		console.error("Error loading weight units:", error)
		toast.add({
			severity: "error",
			summary: "Error",
			detail: "Failed to load weight units",
			life: 3000,
		})
	}
}

onMounted(async () => {
	await refreshEmissionFactorOptions()
	// Check if weighted calculation option is enabled
	const weightedFlag = await featureFlagClient.getByName("Weighted Calculation Option")
	weightedOptionEnabled.value = weightedFlag?.isEnabled || false

	// Load weight-based units
	await loadWeightUnits()
})

class OverlayDataClass {
	data: ProductProcessProxy
	date: string | undefined
}

const op = ref<InstanceType<typeof Popover> | null>(null)

const selectedDataForOverlay = ref<OverlayDataClass[]>([] as OverlayDataClass[])

const showOverlay = (event: MouseEvent, PPDatas: ProductProcessProxy[]) => {
	selectedDataForOverlay.value = [] as OverlayDataClass[]
	PPDatas.forEach((PPData) => {
		selectedDataForOverlay.value.push({
			date: PPData.createdTimeStamp?.toDateString(),
			data: PPData,
		})
	})

	if (op.value) op.value?.show(event)
}

const hideOverlay = () => {
	if (op.value) op.value?.hide()
}
const props = defineProps({
	assessmentId: {
		type: String,
		required: false,
		default: "",
	},
	tabId: {
		type: String,
		required: false,
		default: "",
	},
	tabName: {
		type: String,
		required: false,
		default: "",
	},
	steps: {
		type: Array as () => Step[],
		default: () => [],
	},
	intermediates: {
		type: Array as () => IntermediateStep[],
		default: () => [],
	},
})

//dialog result
//dialog result
const saveAttempted = ref()
const dialogSaveResult2 = ref(false)
const resultName = ref("")
const showEmissionFactors = ref(false)
const retrieveData = ref()
const retrieveEmissionFactors = ref<{ [key: string]: number }>()
const resultDescription = ref()
const resultSaveButton = ref(false)
const displayResult = ref(false)
const displayValidationRunning = ref(false)
const displayWarning = ref(false)
const warningMessage = ref()
const tabData = ref()
const status = ref()
const actualSavedResultText = ref<string>()
const actualSavedResult = ref<ProductProcessProxy[]>([] as ProductProcessProxy[])
const isWeighted = ref(false)
const weightedOptionEnabled = ref(false)
const visibleEmissionFactors = computed(() => reportsStore.getVisibleEmissionFactors(isWeighted.value))
const activeEmissionFactors = computed(() => reportsStore.getSelectedEmissionFactors(isWeighted.value))

// New fields for output quantity and step selection
const ALL_STEPS_VALUE = "__ALL_STEPS__"
const outputQuantity = ref<number | undefined>(1)
const selectedUnit = ref<string | undefined>(undefined)
const selectedStep = ref<string | null>(ALL_STEPS_VALUE)

// Computed property for calculation options
const calculationOptions = computed(() => {
	return new CalculationOptions({
		emissionFactorsToUse: reportsStore.selectedEmissionFactorNames,
		useWeightedEmissionFactors: isWeighted.value,
		outputQuantity: outputQuantity.value,
		selectedUnitId: selectedUnit.value,
		selectedStepId: selectedStep.value === ALL_STEPS_VALUE ? undefined : selectedStep.value || undefined,
	})
})
const weightUnits = ref<Unit[]>([] as Unit[])

// Computed property to filter and sort provided steps from props
const availableSteps = computed(() => {
	return props.steps.filter((s) => s.isActive !== false).sort((a, b) => (a.stepNumber || 0) - (b.stepNumber || 0))
})

// Computed property to include "All Steps" option
const stepsWithAllOption = computed(() => {
	const allStepsOption: Step = {
		id: ALL_STEPS_VALUE,
		stepNumber: null,
		stepName: "All Steps",
	} as any
	return [allStepsOption, ...availableSteps.value]
})

// Computed properties to get actual Unit and Step objects
const selectedUnitObject = computed(() => {
	return weightUnits.value.find((u) => u.id === selectedUnit.value)
})

const selectedStepObject = computed(() => {
	if (selectedStep.value === ALL_STEPS_VALUE) {
		return new Step({ stepName: "All Steps", stepNumber: undefined } as any)
	}
	return availableSteps.value.find((s) => s.id === selectedStep.value)
})

// Snapshot of step/unit at the time of last calculation
// These are used for display in child component titles so they only update on Calculate click
const calculatedStepObject = ref<Step | undefined>(undefined)
const calculatedUnitObject = ref<Unit | undefined>(undefined)

// Computed property to determine if calculated step is last step or all steps
const isLastStepOrAllSteps = computed(() => {
	if (!calculatedStepObject.value) return true

	// Check if "All Steps" was selected
	if (calculatedStepObject.value.stepNumber === undefined || calculatedStepObject.value.stepNumber === null) {
		return true
	}

	// Find the last step (highest step number)
	const lastStep = availableSteps.value.reduce((max: Step, step) => {
		return (step.stepNumber ?? 0) > (max.stepNumber ?? 0) ? step : max
	}, availableSteps.value[0])

	// Check if calculated step is the last step
	return calculatedStepObject.value.id === lastStep?.id
})

// Computed property for output quantity description
const outputQuantityDescription = computed(() => {
	const quantity = outputQuantity.value ?? 1
	const unitName = calculatedUnitObject.value?.unitName || "kg"

	if (isLastStepOrAllSteps.value) {
		return `per ${quantity} ${unitName} drug product of all steps`
	} else {
		return `per ${quantity} ${unitName} of intermediate drug product`
	}
})

//communication with sub tabs
const childResultByLifeStage = ref()
const childResultByStep = ref()
const childResultByMaterialComposition = ref()
const childREsultBYProcessWaste = ref()
var generalInformationId = ref()

// Step flow visualization
const stepGraph = ref<{ nodes: Node[]; edges: Edge[] }>({ nodes: [], edges: [] })
const stepGraphKey = ref(0)

// Biologics has no flow connections — highlight all steps up to and including the selected step number.
const highlightedNodeIds = computed((): Set<string> | undefined => {
	if (!selectedStep.value || selectedStep.value === ALL_STEPS_VALUE) return undefined
	const selectedStepNumber = availableSteps.value.find((s) => s.id === selectedStep.value)?.stepNumber ?? 0
	return new Set(availableSteps.value.filter((s) => (s.stepNumber ?? 0) <= selectedStepNumber && s.id != null).map((s) => s.id!))
})

const highlightPath = computed(() => (highlightedNodeIds.value ? computeHighlightPath(stepGraph.value.nodes, highlightedNodeIds.value) : ""))

//child components
const resultStepBiologicsAGControl = ref<InstanceType<typeof resultStepBiologicsAG>>()
const resultByStepBiologicsAGControl = ref<InstanceType<typeof resultByStepBiologicsAG>>()
const resultByMaterialCompositionBiologicsAGControl = ref<InstanceType<typeof resultByMaterialCompositionBiologicsAG>>()
const resultByProcessWasteBiologicsAGControl = ref<InstanceType<typeof resultByProcessWasteBiologicsAG>>()

// Function to normalize emission factor names for comparison
const normalizeEmissionFactorName = (name: string): string => {
	return name
		.toLowerCase()
		.replace(/\s+/g, "") // Remove all spaces
		.replace(/[()]/g, "") // Remove parentheses
		.replace(/-/g, "") // Remove dashes
}

// Function to find the value for an emission factor by matching normalized names
const getEmissionFactorValue = (emissionFactorName: string): number | null => {
	if (!retrieveEmissionFactors.value) return null

	const normalizedSearchName = normalizeEmissionFactorName(emissionFactorName)

	// Search through all keys in retrieveEmissionFactors
	for (const key in retrieveEmissionFactors.value) {
		const normalizedKey = normalizeEmissionFactorName(key)
		if (normalizedKey === normalizedSearchName) {
			return retrieveEmissionFactors.value[key]
		}
	}

	return null
}

// Build step graph for visualization
async function buildStepGraph(steps: Step[]) {
	if (steps.length === 0) {
		return { nodes: [], edges: [] }
	}

	try {
		// Find the final step (highest step number)
		const finalStep = steps.reduce((max: Step, step) => {
			return (step.stepNumber ?? 0) > (max.stepNumber ?? 0) ? step : max
		})

		// Create edges from intermediates
		const edges = props.intermediates.map(
			(i) =>
				({
					id: i.id,
					source: i.intermediateStepId,
					target: i.stepId,
					markerEnd: "arrowclosed",
				}) as Edge
		)

		// Create nodes from steps
		const nodes = steps.map((s) => {
			const isFinalStep = s.id === finalStep?.id
			const isTarget = edges.some((e) => e.target === s.id)

			let type = "step"
			if (isFinalStep) type = "final"
			else if (isTarget) type = "has-intermediate"

			return {
				id: s.id,
				type: type,
				data: {
					label: s.stepNumber,
					status: "healthy",
					errors: [],
					tooltip: `${s.stepNumber}-${s.stepName}`,
				},
			} as Node
		})

		// Use layout function to position nodes
		const result = await layout(nodes, edges, "DOWN")

		return result
	} catch (error) {
		console.error("Error building step graph:", error)
		return { nodes: [], edges: [] }
	}
}

onMounted(() => {
	EventBus.on("saveResult_" + props.tabId, (data: any) => {
		retrieveData.value = data[5]
		dialogSaveResult2.value = true
	})
	EventBus.on("readyToSaveResult_" + props.tabId, () => {
		resultSaveButton.value = true
	})
	EventBus.on("BiologicschildResultByLifeStage_" + props.tabId, (data: any) => {
		const typedData = data as LifeCycleResult[]
		childResultByLifeStage.value = typedData
		checkIfResultsWasSavedBefore(typedData)
	})
	EventBus.on("BiologicschildResultByStep_" + props.tabId, (data: any) => {
		childResultByStep.value = data
	})
	EventBus.on("BiologicschildResultByMaterialComposition_" + props.tabId, (data: any) => {
		childResultByMaterialComposition.value = data
	})
	EventBus.on("BiologicschildResultByProcessWaste_" + props.tabId, (data: any) => {
		childREsultBYProcessWaste.value = data
	})
	EventBus.on("validateResult_" + props.tabId, (data: any) => {
		if (data != null && data.generalInformationId != null) {
			tabData.value = data
			generalInformationId.value = data.generalInformationId
			displayValidationRunning.value = true
			validateResultMatrix(props.tabId, data)
		}
	})
})

const checkIfResultsAreAlreadySavedForThisTabAssessment = async () => {
	try {
		var res = await apiClient.getProxyByScreenAndAssessment(props.tabId, props.assessmentId)
		if (res && res.length > 0) {
			actualSavedResult.value = res
			// actualSavedResultText.value = "There are " + res.length + " results already saved for this assessment"
			actualSavedResultText.value = "Saved results are available for use as an API"
		}
	} catch (err) {
		throw new Error(`Network response was not ok: ${err}`)
	}
}
const overwriteConfimation = () => {
	confirm.require({
		message: "Biologics results for this assessment have already been saved, are you sure you want to overwrite them?",
		header: "Confirmation",
		icon: "pi pi-exclamation-triangle",
		rejectClass: "btn-primary",
		rejectLabel: "Cancel",
		acceptLabel: "Save",
		accept: () => {
			saveTheResult("overwrite")
		},
		reject: () => {
			dialogSaveResult2.value = false
		},
	})
}

function validateResultMatrix(tabId: string, data: any) {
	if (data != null && data.generalInformationId != null) {
		apiClient.validateResultMatrixByGeneralInformationId(data.generalInformationId).then(
			(res) => {
				displayValidationRunning.value = false

				if (res != null && res.length > 0) {
					displayResult.value = false

					console.log(res)
					// Extract messages using ValidationMessage properties
					const warnings = res.filter((item) => item.messageType === "Warning").map((item) => item.messageText!)
					const errors = res.filter((item) => item.messageType === "Error").map((item) => item.messageText!)

					console.log(warnings, errors)

					// Combine warnings and errors for display
					warningMessage.value = [...warnings, ...errors]
					displayWarning.value = warningMessage.value.length > 0
				} else {
					displayResult.value = false
					displayWarning.value = false
					warningMessage.value = []
				}
			},
			(err) => {
				displayValidationRunning.value = false
				if (err.status == 400) {
					displayResult.value = false
					console.error("Error Id:", err.response.errorId)
					warningMessage.value = err.response.message
					displayWarning.value = true
				} else {
					toast.add({ severity: "error", summary: `Error: ${err}`, life: 2000 })
				}
			}
		)
	}
}

const invokeResult = async () => {
	// Snapshot current selections for display in child titles
	calculatedStepObject.value = selectedStepObject.value
	calculatedUnitObject.value = selectedUnitObject.value

	displayResult.value = true
	resultByStepBiologicsAGControl.value!.getResults(generalInformationId.value)
	resultByMaterialCompositionBiologicsAGControl.value!.getResults(generalInformationId.value)
	resultByProcessWasteBiologicsAGControl.value!.getResults(generalInformationId.value)
	resultStepBiologicsAGControl.value!.getResults(generalInformationId.value)
	checkIfResultsAreAlreadySavedForThisTabAssessment()
}

onActivated(async () => {
	await refreshEmissionFactorOptions()
})

watch(
	isWeighted,
	() => {
		if (displayResult.value) {
			invokeResult()
		}
	},
	{ flush: "post" }
)

// Watch for changes in steps, intermediates, or selected step to rebuild the graph
watch(
	[availableSteps, () => props.intermediates, selectedStep],
	async ([newSteps, newIntermediates, newSelectedStep]) => {
		if (newSteps.length > 0) {
			stepGraph.value = await buildStepGraph(newSteps)
		} else {
			stepGraph.value = { nodes: [], edges: [] }
		}
		// Always increment key to force re-render and recenter
		stepGraphKey.value++
	},
	{ deep: true, immediate: true }
)

function exportCalculationLog() {
	apiClient.getBiologicsCalculationLog(generalInformationId.value, calculationOptions.value).then(
		(res) => {
			var fileURL = window.URL.createObjectURL(new Blob([res.data]))
			var fileLink = document.createElement("a")

			fileLink.href = fileURL
			var fileName = `Calculation_Log`
			fileLink.setAttribute("download", fileName + ".xlsx")
			document.body.appendChild(fileLink)
			fileLink.click()

			window.URL.revokeObjectURL(fileURL)
			document.body.removeChild(fileLink)
		},
		(error) => {
			status.value = error
		}
	)
}

async function exportToBody() {
	if (reportsStore.selectedEmissionFactorNames.length === 0) {
		toast.add({
			severity: "warn",
			summary: "Warning",
			detail: "Please select at least one emission factor to export",
			life: 5000,
		})
		return
	}

	try {
		var allResults = new AllResultsOther()
		allResults.lifeCycleResults = resultStepBiologicsAGControl.value?.getResultData() ?? []
		allResults.lifeCycleResultsByStep = resultByStepBiologicsAGControl.value?.getResultData() ?? []
		allResults.materialCompositionResults = resultByMaterialCompositionBiologicsAGControl.value?.getResultData() ?? []
		allResults.customProcessWasteEOLs = resultByProcessWasteBiologicsAGControl.value?.getResultData() ?? []

		const exportRequest = new ExportRequestOther({
			allResults: allResults,
			emissionFactorNames: reportsStore.selectedEmissionFactorNames,
			isWeighted: isWeighted.value,
			assessmentId: props.assessmentId,
			generalInformationId: generalInformationId.value ?? undefined,
		})

		const response = await apiClient.downloadReportOthers(props.tabId, exportRequest)

		// Download file
		const blob = response.data
		const fileURL = window.URL.createObjectURL(blob)
		const fileLink = document.createElement("a")
		fileLink.href = fileURL
		const fileName = response.fileName || `Eco-Design ${props.tabName} Report_${Date.now()}.xlsx`
		fileLink.setAttribute("download", fileName)
		document.body.appendChild(fileLink)
		fileLink.click()
		window.URL.revokeObjectURL(fileURL)
		document.body.removeChild(fileLink)

		toast.add({
			severity: "success",
			summary: "Success",
			detail: "Report exported successfully",
			life: 3000,
		})
	} catch (err: any) {
		console.error("Export error:", err)
		toast.add({
			severity: "error",
			summary: "Error",
			detail: "Failed to export Excel file. Please try again.",
			life: 3000,
		})
	}
}
const prepareForChecking = (num: number | undefined) => {
	if (num === undefined) return 0
	return parseFloat((num ?? 0).toFixed(6).toString())
}

const checkIfResultsWasSavedBefore = async (actualResults: LifeCycleResult[]) => {
	try {
		var res = await apiClient.getProxyByScreenAndAssessment(props.tabId, props.assessmentId)
		var oneResult = res[0]
		var actualValuesToCheck = actualResults.find((item: LifeCycleResult) => item.name === "Total")

		if (oneResult && actualValuesToCheck) {
			let check =
				prepareForChecking(actualValuesToCheck.climateChange) !== oneResult.climateChange ||
				prepareForChecking(actualValuesToCheck.water) !== oneResult.pmiWater ||
				prepareForChecking(actualValuesToCheck.waterConsumption) !== oneResult.waterUseConsumption ||
				prepareForChecking(actualValuesToCheck.costofGoods) !== oneResult.goodsCost ||
				prepareForChecking(actualValuesToCheck.solvent) !== oneResult.pmiSolvent
			//parseFloat(actualValuesToCheck.solvent?.toFixed(6).toString()) !== oneResult.pmiSolvent
			actualSavedResultText.value = "Saved results are available for use as an API"
		}
	} catch (err) {
		throw new Error(`Network response was not ok: ${err}`)
	}
}
function saveTheResult(saveType: string) {
	saveAttempted.value = true
	resultName.value = resultName.value?.trim() ?? ""

	if (resultName.value == "" || resultName.value == undefined || resultName.value == null) {
		toast.add({
			severity: "error",
			summary: "Error",
			detail: "Please enter result name",
			life: 2500,
		})
		return
	}

	// Include ALL emission factors in save, not just selected ones
	const allEmissionFactors: { [key: string]: number } = {}
	if (retrieveEmissionFactors.value) {
		for (const ef of reportsStore.emissionFactors) {
			const value = getEmissionFactorValue(ef.emissionFactorName!)
			if (value !== null && ef.id) {
				// Use the emission factor ID as the key (required by API)
				allEmissionFactors[ef.id] = value
			}
		}
	}

	var saveIt = new DataToSave()
	saveIt.assessmentId = props.assessmentId
	saveIt.materialName = resultName.value
	saveIt.materialDescription = resultDescription.value
	saveIt.climateChange = retrieveData.value.climateChange
	saveIt.water = retrieveData.value.water
	saveIt.waterConsumption = retrieveData.value.waterConsumption
	saveIt.costOfGoods = retrieveData.value.costofGoods
	saveIt.solvent = retrieveData.value.solvent
	saveIt.pmi = retrieveData.value.total
	saveIt.emissionFactors = allEmissionFactors
	saveIt.screenId = props.tabId
	apiClient.saveProxyForProductProcess(saveType, saveIt).then((res) => {
		const duplicateResult = parseDuplicateResultResponse(res)
		if (duplicateResult) {
			toast.add({
				severity: "warn",
				summary: "Warning",
				detail: `Saved values with name '${duplicateResult.name}' already exists on ${duplicateResult.path}. Please use a unique name for your results`,
				life: 10000,
			})
			return
		}

		switch (res) {
			case "exists":
				overwriteConfimation()
				break
			case "error":
				toast.add({
					severity: "warn",
					summary: "Warning",
					detail: "An error occurred while saving the result",
					life: 2500,
				})
				break
			default:
				dialogSaveResult2.value = false
				checkIfResultsAreAlreadySavedForThisTabAssessment()
				break
		}
	})
}
const saveResult = async () => {
	// saveAttempted.value = false
	try {
		const assessmentDetail = await apiClient.getSingleAssessmentById(props.assessmentId)
		const existingSavedResult = actualSavedResult.value[0]
		resultName.value = existingSavedResult?.materialName?.trim() || buildAssessmentResultName(assessmentDetail)
		resultDescription.value = existingSavedResult?.comments || ""
		EventBus.emit("getResultDataToSave_" + props.tabId)
		if (generalInformationId.value) {
			try {
				const fullResults = await apiClient.getBiologicsResultsForSave(generalInformationId.value)
				retrieveEmissionFactors.value = fullResults
			} catch (error) {
				console.error("Error fetching full synthetic results:", error)
				toast.add({
					severity: "error",
					summary: "Error",
					detail: "Failed to load emission factor results",
					life: 3000,
				})
			}
		}
		saveAttempted.value = false
	} catch (err) {
		throw new Error(`Network response was not ok: ${err}`)
	}
}

// Watch for changes in steps, intermediates, or selected step to rebuild the graph
watch(
	[availableSteps, () => props.intermediates, selectedStep],
	async ([newSteps, newIntermediates, newSelectedStep]) => {
		if (newSteps.length > 0) {
			stepGraph.value = await buildStepGraph(newSteps)
		} else {
			stepGraph.value = { nodes: [], edges: [] }
		}
		// Always increment key to force re-render and recenter
		stepGraphKey.value++
	},
	{ deep: true, immediate: true }
)

function changeTab(ev: any) {}
</script>
<style scoped></style>
